/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import MultiPrint from "./lib/multiprint";

import {debounce} from 'debounce';

require('./bootstrap');

require("tablesorter");
require("selectize");
require("timeago");
require("bootstrap-datepicker");
// add supported languages.
require("../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.fr");
require("../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.nl");
require("../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.de");
require("../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.el");
require("../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.es");
require("../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.pl");
require("../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.ro");
require("../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.sq");
require("../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.bg");
require("../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.zh-CN");


window.Pusher = require('pusher-js');
import Echo from 'laravel-echo';

window.io = require('socket.io-client');
// window.Echo = new Echo({
//     broadcaster: 'socket.io',
//     host: window.location.hostname + ':6001',
//     transports: ['websocket', 'polling', 'flashsocket']
// });



import Error from './lib/error';

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    url: "/api",
    type: "POST"
});

$(document).ajaxSuccess(function( event, xhr, settings ) {

    if (xhr.responseJSON) {
        if (xhr.responseJSON.op == "redirect") {
            if (settings.data.indexOf("noredirect=1") === -1) {
            	window.location = xhr.responseJSON.url;
            }
        } else if (xhr.responseJSON.op == "error") {
            new Error("Error", xhr.responseJSON.message, xhr.responseJSON.retain);
        }
    }

});


import CountryEditor from './lib/country-editor';
import EditionEditor from './lib/edition-editor';
import Confirmer from './lib/confirm';
import Uploader from './lib/uploader';
import AssetPreview from './lib/asset-preview';
import Assets from './lib/assets';
import AddAsset from './lib/addasset';
import CompanyMerge from './lib/company-merge';
import Search from './lib/search';
import RegistrationProfile from './lib/reg-profile';
import ApplicationEditor from './lib/app-editor';
import CompanyType from './lib/companytype';
import CreateInvoice from './lib/createinvoice';
import CreateQuotation from './lib/createquotation';
import EditQuotation from './lib/editquotation';
import AddPayment from './lib/addpayment';
import CountryRegModal from './lib/country-reg-modal';
import Dashboard from './lib/dashboard';
import RegistrationApplication from './lib/reg-application';
import AddCreditNote from './lib/addcreditnote';
import Sorter from './lib/table-sort';
import AddProduct from "./lib/addproduct";
import CreateForm from "./lib/create-form";
import AssetModal from "./lib/asset-modal";
import AssetGroup from "./lib/asset-group";
import FormGenerator from "./lib/form-generator";
import ExcelRange from "./lib/excel-range";
import Multifooter from "./lib/multifooter";
import FooterSelector from "./lib/footer-selector";
import Editablefooter from "./lib/editablefooter";
import PDFRange from "./lib/pdf-range";
import Mergetool from "./lib/mergetool";

const bootstrappedClasses = [
	CountryEditor,
    EditionEditor,
    Confirmer,
    Uploader,
    AssetPreview,
    Assets,
    AddAsset,
    CompanyMerge,
    Search,
    RegistrationProfile,
    ApplicationEditor,
    CompanyType,
    CreateInvoice,
    CreateQuotation,
    AddPayment,
    EditQuotation,
    CountryRegModal,
    Dashboard,
    RegistrationApplication,
    AddCreditNote,
    Sorter,
    MultiPrint,
    AddProduct,
    CreateForm,
    AssetGroup,
    FormGenerator,
  ExcelRange,
    Multifooter,
  FooterSelector,
  Editablefooter,
    PDFRange,
  Mergetool,
];

window.Uploader = Uploader;
// fake lang
window.Lang = {get: (str) => str};


$(() => {

    $(bootstrappedClasses).each((i, c) => {
		new c();
	});

    window.assetModal = new AssetModal();

    if ($("#client_fields").length > 0) {
        Vue.component('client-fields', () => import("./components/ClientFields.vue"));
        
        
        new Vue({
            el: "#client_fields",
            data: {
            }
        });
    }
    
    if ($("#sku-table").length > 0) {
        Vue.component('sku-table', () => import("./components/SKUTable.vue"));
        new Vue({
            el: "#sku-table",
            data: {
                columns: window.SKU_COLUMNS,
                rows: window.SKU_ROWS
            }
        });
    }


    $("table.sortable").each((i, table) => {
        let width = $(table).find("th").length - 1;
        let options = {headers: {}, dateFormat: "ddmmyyyy"};
        if ($(table).hasClass("autosorted")) {
            let dir = $(table).hasClass("asc") ? 0 : 1;
            options.sortList = [[0,dir]];
        }
        options.headers[width] = {sorter: false, cssChildRow: "tablesorter-childRow"};
        $(table).tablesorter(options)
    });

    $(".multiselect").selectize({
        plugins: ['remove_button']
    });

    // setup main menu
    let nav = $("#navbar ul:eq(0)");
    let sidebar = $("#navbar ul.nav-sidebar");
    $(sidebar).find("li").each((i, li) => {
        $(li).addClass("visible-xs");
        $(nav).append(li);
    });
    $(sidebar).detach();
    $("#navbar h3").detach();



    $(".view-reg-user").each((i, view) => {
        $(view).click(e => {
            let id = $(view).data("id");

            $("#viewRegUserModal .modal-title").html("Loading...");
            $("#viewRegUserModal .modal-body").html("Loading...");
            $.ajax({
                data:{op:"getRegUser",id:id},
                success: (d, s) => {
                    $("#viewRegUserModal .modal-title").html(d.title);
                    $("#viewRegUserModal .modal-body").html(d.body);

                }
            });
        })
    })


    //
    if (window.location.hash != "") {
        let hash = window.location.hash;
        let arr = hash.split(":");
        if (arr.length == 2) {
            let id = arr[1];
            window.assetModal.showAsset(id);
        }
    }
    
    // password checker.
    
    
    $("#password").keyup(debounce(e => {
        let password = e.target.value;
        
        let data = window.userdata || [];
        if ($("#email").length > 0) {
            data.push($("#email").val());
        }

        $.ajax("/passcheck", {
            method: "post",
            data: {
                password: password,
                userdata: data
            },
            success: (d, s)  => {
                let score = 1 * d;
                if (isNaN(score)) {
                    score = 0;
                }
                console.log(score);
                let perc = score * 100 / 4;
                if (perc === 0 && password !== "") {
                    perc = 10;
                }
                $("#progress-bar").width(perc + "%").removeClass();

                $("#progress-bar").addClass("progress-bar");

                if (score <= 2) {
                    $("#progress-bar").addClass("progress-bar-danger");
                } else if (score === 3) {
                    $("#progress-bar").addClass("progress-bar-success");
                } else {
                    $("#progress-bar").removeClass("progress-bar-danger");
                    $("#progress-bar").removeClass("progress-bar-success");
                }

                $("#progress-bar").html(["weak", "weak", "fair", "good", "strong"][score]);

                if (score > 2) {
                    $(e.target).parentsUntil(".form-group").removeClass("has-error");
                } else {
                    $(e.target).parentsUntil(".form-group").addClass("has-error");
                }
                
            }
        })
        
    
    }, 200))

    if ($("#user_countries").length > 0) {
        Vue.component('user-notifications', () => import("./components/UserNotifications.vue"));

        new Vue({
            el: "#user_countries",
            data: {
            },
        });
        
        
    }

    if ($("#edition_products").length > 0) {

        Vue.component('edition', () => import("./components/Edition.vue"));

        new Vue({
            el: "#edition_products",
            data: {
            },
        });
    }

    if ($("#settings").length > 0) {

        Vue.component('settings', () => import("./components/Settings.vue"));

        new Vue({
            el: "#settings",
            data: {
            },
        });
    }

  $(".edit-po").click(e => {
    e.preventDefault();
    const oldvalue = $(e.currentTarget).data("value") ?? '';
    const data = $(e.currentTarget).data("data");
    if (!data) {
      return;
    }
    const newval = window.prompt("Enter new PO Number", oldvalue)
    if (newval === null || newval === oldvalue) {
      return;
    }
    $.ajax({
      data: {...data, po: newval },
      success: (d, s) => {
        window.location.reload();
      }
    })
  });



})
